import getCharts from '../getCharts'
import { QuestionProvider } from '../../constants/api.config'

export default async function SaveQuestionProvider(mode = "GET", questionID = "-1", questionType = "-1", diagnosisID = "-1", questionData = "-1") {
    try {
        const payload = { mode, questionType, diagnosisID, questionData, questionID }
        const res = await getCharts(QuestionProvider, payload)
        return res.data
    } catch (error) {
        return error
    }
}
